(() => {
  const accountShared = window.AuremeAccountShared;
  if (!accountShared) {
    console.error('[aureme-point-cache] AuremeAccountShared is not loaded.');
    return;
  }

  const STORAGE_KEYS = accountShared.storageKeys;

  /**
   * App Proxy の /point を取得し localStorage に保存する（DOM は更新しない）
   * @param {string} customerId
   * @returns {Promise<{ point: unknown, rankId: unknown, rankName: unknown } | null>}
   */
  async function fetchPointAndPersistLocalStorage(customerId) {
    let result = { point: null, rankId: null, rankName: null };
    const now = Date.now();

    try {
      const response = await fetch(
        `https://${AUREME_STORE_DOMAIN}${SANYO_APP_PROXY_PATH}/point`,
      );
      if (!response.ok) throw new Error('point fetch failed');
      const json = await response.json();
      if (json.error_flg) throw new Error('point payload error');
      result.point = json.point;
      result.rankId = json.rankId;
      result.rankName = json.rankName;
    } catch {
      return null;
    }

    try {
      const point = result.point != null ? Number(result.point) : 0;
      localStorage.setItem(STORAGE_KEYS.point + customerId, String(point));
      localStorage.setItem(
        STORAGE_KEYS.rankId + customerId,
        result.rankId != null ? String(result.rankId) : '',
      );
      localStorage.setItem(
        STORAGE_KEYS.rankName + customerId,
        result.rankName != null ? String(result.rankName) : '',
      );
      localStorage.setItem(STORAGE_KEYS.expire + customerId, String(now));
    } catch {
      return null;
    }

    return result;
  }

  function isPointCacheFresh(customerId) {
    try {
      const rankId = localStorage.getItem(STORAGE_KEYS.rankId + customerId);
      const expireStr = localStorage.getItem(STORAGE_KEYS.expire + customerId);
      if (!rankId || !expireStr) return false;
      const expireMs = parseInt(expireStr, 10);
      if (Number.isNaN(expireMs)) return false;
      return Date.now() < expireMs + Number(AUREME_POINT_CACHE_TTL);
    } catch {
      return false;
    }
  }

  function isCartPage() {
    if (typeof routes === 'undefined' || !routes.cart_url) return false;

    const currentPath = window.location.pathname.replace(/\/$/, '');
    const cartPath = routes.cart_url.replace(/\/$/, '');
    return currentPath === cartPath;
  }

  function warmPointCacheIfNeeded() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    if (isCartPage()) return;

    const id = AUREME_CUSTOMER_ID;
    if (id === '' || id === null || id === undefined) return;

    const customerId = String(id);
    if (!customerId) return;
    if (!SANYO_APP_PROXY_PATH || !AUREME_STORE_DOMAIN) return;
    if (document.documentElement.dataset.auremePointCacheWarm === '1') return;
    if (isPointCacheFresh(customerId)) return;

    document.documentElement.dataset.auremePointCacheWarm = '1';
    void fetchPointAndPersistLocalStorage(customerId);
  }

  window.AuremePointCache = {
    fetchPointAndPersistLocalStorage,
    isPointCacheFresh,
    warmPointCacheIfNeeded,
  };

  if (document.readyState === 'complete') {
    warmPointCacheIfNeeded();
  } else {
    document.addEventListener('DOMContentLoaded', warmPointCacheIfNeeded);
  }
})();

